import React from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'

import './DebitPaymentContent.css'

const DebitPaymentContent = ({t}) =>
  <div className='debit-container'>
    <span>{t('common:payment:debit:instruction')}</span>
    <ul className='debit-list'>
      <li>{t('common:payment:debit:identity_cards')}</li>
      <li>{t('common:payment:debit:rib')}</li>
    </ul>
    <span>{t('common:payment:debit:upon_receipt')}</span>
    <span>{t('common:payment:debit:attached_mandate')}</span>
  </div>

DebitPaymentContent.propTypes = {t: func}

export default translate()(DebitPaymentContent)



// WEBPACK FOOTER //
// ./src/components/customer/wallet/payments/debit/DebitPaymentContent.js